/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input.ng-invalid[_ngcontent-%COMP%]{border:1px solid #ff6000}input.form-check-input[_ngcontent-%COMP%]{margin-left:0;left:0}.input-area[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{width:auto}"];
export { styles as styles };
//# sourceMappingURL=contact-info.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/preferences/contact-info/contact-info.component.scss.shim.ngstyle.js
// module id = 1353
// module chunks = 26 27 28